import * as React from 'react';
import {Helmet} from 'react-helmet';
import {Redirect, Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncUserDocumentListComponent} from '../components/AsyncComponent/AsyncComponent';
import {useTranslation} from "react-i18next";
import {config} from "../config";

const UserDocuments: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('documents.name')}`}</title>
                <meta name="description" content="Documents"/>
            </Helmet>
            <Switch>
                <Route
                    exact
                    path={`${match?.url}/:id([0-9]+)`}
                    component={AsyncUserDocumentListComponent}
                />
                <Redirect exact from={`${match?.url}/`} to={`${match?.url}`}/>
            </Switch>
        </div>
    );
};

export default UserDocuments;
